module.exports = "<header v-if=user> <input placeholder=Search v-model=searchQuery debounce=500> <div> <span>{{user.userTitle}}</span> <img :src=user.imageUrl alt={{user.userTitle}} /> <a href=# v-on:click.prevent=signOut> <i class=\"fa fa-sign-out\" aria-hidden=true></i> </a> </div> </header>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
 ** module id = 80
 ** module chunks = 0
 **/